// Environment Configuration
export const ENV_CONFIG = {
  development: {
    API_BASE_URL: 'http://127.0.0.1:5001',
  },
  production: {
    API_BASE_URL: 'http://129.204.35.20:5001',
  }
};

// Get current environment
const getCurrentEnv = (): 'development' | 'production' => {
  // Check if we're in development mode
  if (import.meta.env.DEV) {
    return 'development';
  }
  
  // Check hostname for production detection
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'development';
    }
  }
  
  return 'production';
};

export const CURRENT_ENV = getCurrentEnv();
export const CURRENT_CONFIG = ENV_CONFIG[CURRENT_ENV];
